import { render, staticRenderFns } from "./userIntegralDetailsList.vue?vue&type=template&id=613e16bd"
import script from "./userIntegralDetailsList.vue?vue&type=script&lang=js"
export * from "./userIntegralDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports